import Api from '.';

export function listDropdownProfessions() {
  return Api.get('/crud-profession/dropdown/list');
}
